
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.25 6.749v-1.5a1.5 1.5 0 0 0-1.5-1.5h-4m-8.5 0h-4a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5H6","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M14.421 4.736a.751.751 0 0 1-.711.513H7.291a.751.751 0 0 1-.712-.513l-1-3a.749.749 0 0 1 .712-.987h8.418a.749.749 0 0 1 .712.987ZM6.75 20.249H4.5a.75.75 0 0 1-.75-.75V6.749m12.002.75v2.25m-9.002 0h4.5m-4.5 4.5h1.5m4.795 8.47-3.712.53.53-3.712 9.546-9.546a2.25 2.25 0 0 1 3.182 3.182Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    